import React from 'react';
import PropTypes from 'prop-types';
import HtmlContent from '../HtmlContent';
import NavButton from '../../elements/NavButton';

export default class Finish extends React.Component {
  render() {
    const { closeHandler, content } = this.props;
    const {
      AdventCount: {
        translations: {
          common: {
            close,
          },
        },
      },
    } = window;

    return (
      <>
        <div className="adventcount-modal">
          <HtmlContent content={content} />
        </div>
        <div className="adventcount-button-row">
          <NavButton
            toStep=""
            btnLabel={close}
            direction="close"
            clickHandler={closeHandler}
          />
        </div>
      </>
    );
  }
}

Finish.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
};
